import axios from "axios";
import { useEffect, useState } from "react";
import { API } from "../../../config";
import { toast } from "react-toastify";

const LIMIT = 10;

export const useUsers = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const [pagination, setPagination] = useState({
    currentPage: 0,
    totalPages: 0,
    totalUsers: 0,
    limit: LIMIT,
  });
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const handleSearch = (value) => {
    setSearch(value);
  };
  const getUsers = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${API}/Admin/users?page=${page}&limit=${LIMIT}&search=${debouncedSearch}`
      );
      setUsers(response.data.users);
      setPagination(response.data.pagination);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const createUser = async (data) => {
    try {
      const response = await axios.post(`${API}/Admin/users`, {
        email: data.email,
        password: data.password,
        name: data.name,
        companyName: data.companyName,
        phone: data.phone,
      });
      getUsers();
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const updateUser = async (userId, data) => {
    try {
      const response = await axios.put(`${API}/Admin/users/${userId}`, data);
      toast.success("User updated successfully");
      getUsers();
      return response.data;
    } catch (error) {
      console.log(error);
      toast.error("Failed to update user");
      return null;
    }
  };

  useEffect(() => {
    getUsers();
  }, [page, debouncedSearch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => clearTimeout(timer);
  }, [search]);

  return {
    users,
    search,
    pagination,
    page,
    setPage,
    loading,
    getUsers,
    handleSearch,
    createUser,
    updateUser,
  };
};
